export default __webpack_public_path__ + "static/media/pause.024d221e.ico";